exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.create-btn[data-v-6dc13c02] {\n  margin-bottom: 16px;\n}\n", "", {"version":3,"sources":["/build/src/pages/positionPermissions/Positions.vue","/build/src/pages/positionPermissions/Positions.vue"],"names":[],"mappings":";AAsDA;EACE,oBAAA;CCrDD","file":"Positions.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.create-btn {\n  margin-bottom: 16px;\n}\n",".create-btn {\n  margin-bottom: 16px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6dc13c02","scoped":true,"hasInlineConfig":false}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/positionPermissions/Positions.vue
// module id = cPfL
// module chunks = 176